import {
	SIDE_NAV_DARK,
	NAV_TYPE_SIDE,
	DIR_LTR,
} from "constants/ThemeConstant";
import { env } from "./EnvironmentConfig";

export const APP_NAME = "TEST IT";
export const API_BASE_URL = env.API_ENDPOINT_URL;
export const APP_PREFIX_PATH = "/app";
export const AUTH_PREFIX_PATH = "/auth";

/** Mesma chave que contabilidade-front; valor = nome do schema PostgreSQL do tenant (ex.: cli_7, tenant_base), enviado em x-tenant */
export const SELECTED_TENANT_STORAGE_KEY = "SELECTED_TENANT_SCHEMA";

export const PUBLIC_PREFIX_PATH = env.PUBLIC_PREFIX_PATH;

export const THEME_CONFIG = {
	navCollapsed: false,
	sideNavTheme: SIDE_NAV_DARK,
	locale: "pt",
	navType: NAV_TYPE_SIDE,
	topNavColor: "#2563eb",
	headerNavColor: "#ffffff",
	mobileNav: false,
	currentTheme: "light",
	direction: DIR_LTR,
};
